import React, { useState } from 'react';
import { HOST, ORG_ID } from 'config';
import VpnKeyRounded from '@mui/icons-material/VpnKeyRounded';
import { useRecordContext } from 'react-admin';
import { authTokenKey } from 'authProvider';
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
} from '@mui/material';

export default function LoginAsButton() {
  const record = useRecordContext() || {};
  const [isLoading, setIsLoading] = useState(false);

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsLoading(true);

    const token = localStorage.getItem(authTokenKey);
    fetch(`${HOST}/${(ORG_ID ? `org/${ORG_ID}/` : '')}auth/login/as`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId: record.id,
      }),
    })
      .then((res) => res.json())
      .then(({ data: { token } }) => {
        window.open(`https://panel.youber.app/auth/login-as?auth_token=${token}`);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Login as failed:', error);
        setIsLoading(false);
      });
  }

  return (
    <>
      <a onClick={handleClick}>
        <VpnKeyRounded />
      </a>

      <Dialog
        open={isLoading}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={3}
          >
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" color="white">
              Redirecting...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
